import {
	Job,
	ContractRates,
	Division,
	Document,
	PrevailingWageInfo,
	PagedResultsOfQuoteLogSummary,
	QuoteListArgs,
	QuoteLog,
	Railroad,
	ServiceType,
	OfferedService,
} from 'src/shared/api';
import { createAction, props } from '@ngrx/store';
import { QuoteDetails } from '../quote-detail.models';

export const offeredServicesToggled = createAction(
	'[Quotes] Offered Services Select Toggled'
);

export const servicesAdded = createAction(
	'[Quotes] Offered Services Added',
	props<{ serviceTypes: ServiceType[] }>()
);
export const servicesRemoved = createAction(
	'[Quotes] Offered Services Removed',
	props<{ serviceTypeIds: number[] }>()
);
export const offeredServicesUpdated = createAction(
	'[Quotes] Offered Services Updated',
	props<{ offeredServices: OfferedService[] }>()
);

export const quoteTurnedIntoJob = createAction(
	'[Quotes] Quote Turned Into Job'
);

export const quoteSaved = createAction(
	'[Quotes] Quote Saved',
	props<{ quote: Job }>()
);

export const newQuoteSaved = createAction(
	'[Quotes] New Quote Saved',
	props<{ quote: Job }>()
);

export const userConfirmedPrevailingWage = createAction(
	'[Quotes] User Confirmed Prevailing Wage',
	props<{ quoteForm: QuoteDetails }>()
);

export const prevailingWagesConfirmed = createAction(
	'[Quotes] Prevailing Wages Confirmed',
	props<{ prevailingWageInfo: PrevailingWageInfo }>()
);

export const invalidContractedRates = createAction(
	'[Quotes] Invalid Contracted Rates'
);

export const errorSavingQuote = createAction(
	'[Quotes] Error Saving Quote',
	props<{ error: any }>()
);
export const saveRequested = createAction(
	'[Quotes] Save Requested',
	props<{ shouldStayOnPage: boolean; formValue: QuoteDetails }>()
);

export const quoteApprovedByRailPros = createAction(
	'[Quotes] Quote Approved By RailPros'
);

export const quoteReportPrinted = createAction(
	'[Quotes] Quote Report Printed',
	props<{ addToDocuments: boolean }>()
);

export const printQuoteReportConfirmed = createAction(
	'[Quotes] Quote Report Confirmed',
	props<{ addToDocuments: boolean }>()
);

export const approveQuoteClicked = createAction(
	'[Quotes] Approve Quote Clicked',
	props<{ note: string; formValue: QuoteDetails }>()
);

export const approveQuoteConfirmed = createAction(
	'[Quotes] Approve Quote Confirmed',
	props<{ note: string; formValue: QuoteDetails }>()
);

export const quoteDetailDestroyed = createAction(
	'[Quotes] Quote Detail Destroyed'
);

export const quoteSelected = createAction(
	'[Quotes] Quote Selected',
	props<{ quoteId: number }>()
);

export const quoteLoadedFromApi = createAction(
	'[Quotes] Quote Loaded From Api',
	props<{ quote: Job }>()
);

export const quoteLoadedFromStore = createAction(
	'[Quotes] Quote Loaded From Store',
	props<{ quote: Job }>()
);

export const errorLoadingQuote = createAction(
	'[Quotes] Error Loading Quote',
	props<{ error: any }>()
);

export const printQuoteReportClicked = createAction(
	'[Quotes] Print Quote Report Clicked'
);

export const newQuoteStarted = createAction('[Quotes] New Quote Started');

export const railroadRatesApplied = createAction(
	'[Quotes] Railroad Rates Applied',
	props<{ contractedRates: ContractRates[] }>()
);

export const customerRatesApplied = createAction(
	'[Quotes] Customer Rates Applied',
	props<{ contractedRates: ContractRates }>()
);

export const railroadSelected = createAction(
	'[Quotes] Railroad Selected',
	props<{ railroadId: number }>()
);

export const updatedRailroadLoaded = createAction(
	'[Quotes] Updated Railroad Loaded',
	props<{ railroad: Railroad }>()
);

export const railroadRequested = createAction(
	'[Quotes] Railroad Requested',
	props<{ railroadId: number }>()
);

export const customerRequested = createAction(
	'[Quotes] Customer Requested',
	props<{ customerId: number }>()
);

export const customerSelected = createAction(
	'[Quotes] Customer Selected',
	props<{ customerId: number }>()
);

export const divisionSelected = createAction(
	'[Quotes] Division Selected',
	props<{ division: Division }>()
);

export const documentsLoaded = createAction(
	'[Quotes] Documents Loaded',
	props<{ documents: Document[] }>()
);

export const quoteLogAdded = createAction(
	'[Quote Logs] Quote Log Added',
	props<{ quoteLog: QuoteLog }>()
);

export const pagedQuoteLogsLoaded = createAction(
	'[Quote Logs] Paged Quote Logs Loaded',
	props<{
		pagedQuoteLogResults: PagedResultsOfQuoteLogSummary;
	}>()
);

export const errorAddingQuoteLog = createAction(
	'[Quote Logs] Error Adding Quote Log',
	props<{ error: any }>()
);

export const quoteLogAddAttempted = createAction(
	'[Quote Logs] Quote Log Add Attempted',
	props<{ quoteLog: QuoteLog }>()
);

export const filtersUpdated = createAction(
	'[Quote Logs] Filters Updated',
	props<{ filters: QuoteListArgs }>()
);

export const noteSubmitted = createAction(
	'[Quote Logs] Note Submitted',
	props<{ note: string }>()
);

export const errorApprovingQuote = createAction(
	'[Quote Logs] Error Approving Quote',
	props<{ errorApprovingQuote: any }>()
);

export const quoteLogDestroyed = createAction(
	'[Quote Logs] Quote Log Destroyed'
);
